module.exports={
	"name": "maps-fe",
	"version": "2.0.7",
	"engines": {
		"node": "16"
	},
	"properties": {
		"api": "/ws/auth-controller/api-v1/maps"
	},
	"repository": {
		"type": "git",
		"url": "https://code.ldschurch.org/git/scm/imos/maps-fe.git"
	},
	"scripts": {
		"bower": "bower install",
		"format": "jsstack-scripts format",
		"upgrade": "jsstack-scripts upgrade",
		"build": "gulp build",
		"test": "gulp unitTests --verbose",
		"develop": "gulp build --env dev",
		"watch": "gulp local --env dev",
		"server": "node node_modules/http-server/bin/http-server ./build/maps-fe -p 9080 -c-1",
		"facade": "facade",
		"verify": " "
	},
	"dependencies": {
		"@churchofjesuschrist/maps-google-converter": "^2.0.5",
		"@churchofjesuschrist/maps-google-label-marker": "^2.0.5",
		"@churchofjesuschrist/maps-google-map": "^2.0.5",
		"@churchofjesuschrist/maps-google-marker": "^2.0.5",
		"@churchofjesuschrist/maps-google-mask": "^2.0.5",
		"@churchofjesuschrist/maps-google-math": "^2.0.5",
		"@churchofjesuschrist/maps-google-overlays": "^2.0.5",
		"@churchofjesuschrist/maps-google-polygons-layer": "^2.0.5",
		"@churchofjesuschrist/maps-google-service-overlay": "^2.0.5",
		"@churchofjesuschrist/maps-service": "^2.0.5",
		"natives": "^1.1.6"
	},
	"devDependencies": {
		"@babel/cli": "^7.20.7",
		"@babel/core": "^7.20.12",
		"@babel/preset-env": "^7.20.2",
		"@babel/register": "^7.18.9",
		"@churchofjesuschrist/jsstack-scripts": "^12.1.0",
		"@churchofjesuschrist/stack-facade": "^4.0.16",
		"babel-eslint": "^9.0.0",
		"babel-plugin-angularjs-annotate": "^0.10.0",
		"babelify": "^10.0.0",
		"bluebird": "^3.7.2",
		"bower": "^1.8.14",
		"bower-art-resolver": "^2.0.10",
		"browser-sync": "^2.27.11",
		"browserify": "^17.0.0",
		"chai": "^4.3.7",
		"connect-history-api-fallback": "^2.0.0",
		"del": "^6.0.0",
		"gulp": "^4.0.2",
		"gulp-add-src": "^1.0.0",
		"gulp-angular-filesort": "^1.2.1",
		"gulp-angular-templatecache": "^2.0.0",
		"gulp-autoprefixer": "^8.0.0",
		"gulp-bower": "^0.0.15",
		"gulp-compile-handlebars": "^0.6.1",
		"gulp-concat": "^2.6.1",
		"gulp-eslint": "^6.0.0",
		"gulp-if": "^3.0.0",
		"gulp-imagemin": "^7.1.0",
		"gulp-inject": "^5.0.5",
		"gulp-jshint": "^2.1.0",
		"gulp-json-editor": "^2.5.6",
		"gulp-rename": "^2.0.0",
		"gulp-replace": "^1.1.4",
		"gulp-sass": "^5.1.0",
		"gulp-sourcemaps": "^3.0.0",
		"gulp-streamify": "1.0.2",
		"gulp-strip-debug": "^4.0.0",
		"gulp-uglify": "^3.0.2",
		"gulp-useref": "^5.0.0",
		"gulp-util": "^3.0.8",
		"gulp-zip": "^5.1.0",
		"http-server": "^14.1.1",
		"jshint": "^2.13.6",
		"jshint-stylish": "^2.2.1",
		"karma": "^6.4.1",
		"karma-browserify": "^8.1.0",
		"karma-chai": "^0.1.0",
		"karma-coverage": "^2.2.0",
		"karma-mocha": "^2.0.1",
		"karma-phantomjs-launcher": "^1.0.4",
		"karma-source-map-support": "^1.4.0",
		"karma-spec-reporter": "^0.0.36",
		"minimist": "^1.2.7",
		"mocha": "^10.2.0",
		"phantomjs-prebuilt": "^2.1.16",
		"rollup-stream": "^1.24.1",
		"vinyl-buffer": "^1.0.1",
		"vinyl-source-stream": "^2.0.0",
		"vinyl-transform": "^1.0.0",
		"watchify": "^4.0.0",
        "sass": "^1.77.0"
	},
	"license": "MIT",
	"babel": {
		"presets": [
			"@babel/preset-env"
		],
		"plugins": [
			"angularjs-annotate"
		]
	}
}
